import { FC, PropsWithChildren } from "react";

const COLUMN_STYLES_MAPPING = {
  2: "flex flex-col sm:block sm:columns-2",
};

type MasonryProps = {
  numberOfColumns?: keyof typeof COLUMN_STYLES_MAPPING;
};
export const Masonry: FC<PropsWithChildren<MasonryProps>> = ({
  children,
  numberOfColumns = 2,
}) => <div className={COLUMN_STYLES_MAPPING[numberOfColumns]}>{children}</div>;
